<template>
  <div id="custGroup">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item>客户设置</el-breadcrumb-item>
          <el-breadcrumb-item>客户分组管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             class="pageSearch">
      <el-form-item label="分组编号::">
        <el-input placeholder="请输入分组编号"
                  v-model="fGroupNo"
                  class="input-with-select">
        </el-input>
      </el-form-item>
      <el-form-item label="分组名称::">
        <el-input placeholder="请输入分组名称"
                  v-model="fGroupName"
                  class="input-with-select">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   icon="el-icon-search"
                   size="small"
                   @click="custGroupQuery">查询</el-button>
      </el-form-item>
      <el-form-item style="float:right">
        <el-button type="primary"
                   size="small"
                   @click="addCustGroup"
                   v-if="is_edit">新增分组</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="groupList"
                highlight-current-row
                border
                style="width: 100%;overflow-y: auto"
                :height="tableHeight"
                ref="singleTable">
        <el-table-column type="index"
                         label="序号"
                         align="right"
                         :index="indexMethod"
                         width="50">
        </el-table-column>
        <el-table-column prop="fGroupNo"
                         width="80"
                         label="分组编号">
        </el-table-column>
        <el-table-column prop="fGroupName"
                         label="分组名称">
        </el-table-column>
        <el-table-column prop="fCustCnt"
                         width="75"
                         label="客户数量"
                         align="right">
        </el-table-column>
        <el-table-column prop="fRemark"
                         label="备注">
        </el-table-column>
        <el-table-column fixed="right"
                         width="240"
                         label="操作"
                         align="center">
          <template slot-scope="scope">
            <el-button @click="viewGroup(scope.$index, scope.row)"
                       type="success"
                       style="background-color:#5bc0de;border-color:#5bc0de"
                       size="mini">查看</el-button>
            <el-button size="mini"
                       type="warning"
                       @click="editGroup(scope.$index, scope.row)"
                       v-if="is_edit">编辑</el-button>
            <el-button size="mini"
                       type="danger"
                       @click="deleteGroup(scope.$index, scope.row)"
                       v-if="is_del">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="custGroupEdit">
      <el-dialog :title="detailTitle"
                 v-dialogDrag
                 :visible.sync="dialogFormVisible"
                 top="7vh"
                 left="0vh">
        <el-form ref="form"
                 :model="curRowInfo"
                 :rules="rules">
          <el-form-item label="分组编号::"
                        :label-width="formLabelWidth"
                        prop="fGroupNo">
            <el-input v-model="curRowInfo.fGroupNo"
                      autocomplete="off"
                      :disabled="!canEditGrpNo"></el-input>
          </el-form-item>
          <el-form-item label="分组名称::"
                        :label-width="formLabelWidth"
                        prop="fGroupName">
            <el-input v-model="curRowInfo.fGroupName"
                      autocomplete="off"
                      :disabled="!curRowInfo.isEdit"></el-input>
          </el-form-item>
          <el-form-item label="备注信息::"
                        :label-width="formLabelWidth"
                        style="padding-bottom: 20px;"
                        prop="fRemark">
            <el-input type="textarea"
                      placeholder="请输入备注"
                      v-model="curRowInfo.fRemark"
                      :disabled="!curRowInfo.isEdit"
                      style="resize: none;max: 100px;"></el-input>
          </el-form-item>
          <el-row style="padding-bottom: 10px">
            <el-col :span="10">
              <el-input placeholder="请输入客户编号或名称"
                        v-model="bindQueryInput"
                        class="input-with-select">
                <el-button slot="append"
                           icon="el-icon-search"
                           @click="bindQuery"></el-button>
              </el-input>
            </el-col>
            <el-col :span="4">&nbsp;</el-col>
            <el-col :span="10">
              <el-input placeholder="请输入客户编号或名称"
                        v-model="unbindQueryInput"
                        class="input-with-select">
                <el-button slot="append"
                           icon="el-icon-search"
                           @click="unbindQuery"></el-button>
              </el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-table :data="curRowInfo.bindCusts"
                        border
                        style="width: 100%;height: 350px"
                        height="350"
                        highlight-current-row
                        @current-change="bindParkChange">
                <el-table-column type="index"
                                 label="序号"
                                 width="50">
                </el-table-column>
                <el-table-column prop="unionName"
                                 label="绑定客户">
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="4"
                    style="text-align: center;">
              <el-row style="padding-top: 60px">
                <el-col :span="24">
                  <el-button type="primary"
                             icon="el-icon-d-arrow-left"
                             style="width: 100px"
                             @click="leftAllBtnClick"
                             :disabled="!curRowInfo.isEdit"></el-button>
                </el-col>
              </el-row>
              <el-row style="padding-top: 20px">
                <el-col :span="24">
                  <el-button type="primary"
                             icon="el-icon-arrow-left"
                             style="width: 100px"
                             @click="leftBtnClick"
                             :disabled="!curRowInfo.isEdit"></el-button>
                </el-col>
              </el-row>
              <el-row style="padding-top: 20px">
                <el-col :span="24">
                  <el-button type="primary"
                             icon="el-icon-arrow-right"
                             style="width: 100px"
                             @click="rightBtnClick"
                             :disabled="!curRowInfo.isEdit"></el-button>
                </el-col>
              </el-row>
              <el-row style="padding-top: 20px">
                <el-col :span="24">
                  <el-button type="primary"
                             icon="el-icon-d-arrow-right"
                             style="width: 100px"
                             @click="rightAllBtnClick"
                             :disabled="!curRowInfo.isEdit"></el-button>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="10">
              <el-table :data="unbindCusts"
                        border
                        style="width: 100%;height: 350px"
                        height="350"
                        highlight-current-row
                        @current-change="unbindCustChange">
                <el-table-column type="index"
                                 label="序号"
                                 width="50">
                </el-table-column>
                <el-table-column prop="unionName"
                                 label="可选客户">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitForm('form')"
                     :loading="btnSaveLoading"
                     v-if="curRowInfo.isEdit">{{this.btnSaveMsg}}</el-button>
          <el-button @click="dialogFormVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { cust as api } from '../../api/cust'
export default {
  name: 'custGroup',
  data () {
    var checkGroupNo = (rule, value, callback) => {
      if (this.canEditGrpNo) {
        let reg = new RegExp('^\\d{4}$')
        if (!reg.test(value)) {
          callback(new Error('组编号为4位数字'))
        }
      }
      callback()
    }
    return {
      is_bind: false,
      groupList: [],
      fGroupNo: '',
      fGroupName: '',
      dialogFormVisible: false,
      formLabelWidth: '120px',
      unbindQueryInput: '',
      bindQueryInput: '',
      unbindCusts: [],
      unbindCustsUI: [],
      rightCust: {},
      canEditGrpNo: true,
      leftCust: {},
      detailTitle: '查看分组',
      btnSaveLoading: false,
      btnSaveMsg: '保存',
      curRowInfo: {
        fGroupID: 0,
        fGroupNo: '',
        fGroupName: '',
        fRemark: '',
        bindCusts: [],
        bindCustsUI: [],
        op: '',
        isEdit: false
      },
      operateFlag: 'view',
      fCustGrpName: '',
      is_edit: false,
      is_del: false,
      tableHeight: 0,
      rules: {
        fGroupName: [
          { required: true, message: '请输入组名称', trigger: 'blur' },
          { min: 1, max: 59, message: '长度在 1 到 59 个字符', trigger: 'blur' }
        ],
        fGroupNo: [
          { required: true, message: '请输入组编号', trigger: 'blur' },
          { validator: checkGroupNo, trigger: 'blur' }]
      },
      pageSize: 20,
      pageNo: 1,
      total: 0
    }
  },
  methods: {
    ...mapActions([
      'getCurrentUserPers', 'getRootParkAndCust'
    ]),
    custGroupQuery () {
      this.initData()
    },
    setDefault () {
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate()
      }
      this.curRowInfo.fRemark = ''
      this.curRowInfo.fGroupID = 0
      this.curRowInfo.fGroupNo = ''
      this.curRowInfo.fGroupName = ''
      this.curRowInfo.bindCusts = []
      this.curRowInfo.bindCustsUI = []
      this.curRowInfo.op = ''
      this.curRowInfo.isEdit = false
    },
    bindQuery () {
      let tmp = this.bindQueryInput.trim()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        let list = []
        Object.assign(list, this.curRowInfo.bindCustsUI)
        this.curRowInfo.bindCusts = list
        return
      }
      var newBindQuery = []
      for (let i = 0; i < this.curRowInfo.bindCustsUI.length; i++) {
        let unionName = this.curRowInfo.bindCustsUI[i].unionName
        if (unionName.indexOf(tmp) > -1) {
          newBindQuery.push(this.curRowInfo.bindCustsUI[i])
        }
      }
      this.curRowInfo.bindCusts = newBindQuery
    },
    unbindQuery () {
      let tmp = this.unbindQueryInput.trim()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        let list = []
        Object.assign(list, this.unbindCustsUI)
        this.unbindCusts = list
        return
      }
      var newUnBindQuery = []
      for (let i = 0; i < this.unbindCustsUI.length; i++) {
        let unionName = this.unbindCustsUI[i].unionName
        if (unionName.indexOf(tmp) > -1) {
          newUnBindQuery.push(this.unbindCustsUI[i])
        }
      }
      this.unbindCusts = newUnBindQuery
    },
    unbindCustChange (cust) {
      this.rightCust = cust
    },
    bindParkChange (cust) {
      this.leftCust = cust
    },
    leftAllBtnClick () {
      if (this.unbindCusts && this.unbindCusts.length > 0) {
        for (let i = 0; i < this.unbindCusts.length; i++) {
          this.curRowInfo.bindCusts.push(this.unbindCusts[i])
          this.curRowInfo.bindCustsUI.push(this.unbindCusts[i])
        }
        this.unbindCusts.splice(0, this.unbindCusts.length)
        this.unbindCustsUI.splice(0, this.unbindCustsUI.length)
      }
    },
    leftBtnClick () {
      if (!this.rightCust || !this.rightCust.fCustID) {
        return
      }
      this.curRowInfo.bindCusts.push(this.rightCust)
      this.curRowInfo.bindCustsUI.push(this.rightCust)
      let index = -1
      for (let i = 0; i < this.unbindCusts.length; i++) {
        if (this.rightCust.fCustID === this.unbindCusts[i].fCustID) {
          index = i
        }
      }
      if (index > -1) {
        this.unbindCusts.splice(index, 1)
        this.unbindCustsUI.splice(index, 1)
      }
    },
    rightBtnClick () {
      if (!this.leftCust || !this.leftCust.fCustID) {
        return
      }
      this.unbindCusts.push(this.leftCust)
      this.unbindCustsUI.push(this.leftCust)
      let index = 0
      for (let i = 0; i < this.curRowInfo.bindCusts.length; i++) {
        if (this.leftCust.fCustID === this.curRowInfo.bindCusts[i].fCustID) {
          index = i
        }
      }
      if (index > -1) {
        this.curRowInfo.bindCusts.splice(index, 1)
        this.curRowInfo.bindCustsUI.slice(index, 1)
      }
    },
    rightAllBtnClick () {
      if (this.curRowInfo.bindCusts && this.curRowInfo.bindCusts.length > 0) {
        for (let i = 0; i < this.curRowInfo.bindCusts.length; i++) {
          this.unbindCusts.push(this.curRowInfo.bindCusts[i])
          this.unbindCustsUI.push(this.curRowInfo.bindCusts[i])
        }
        this.curRowInfo.bindCusts.splice(0, this.curRowInfo.bindCusts.length)
        this.curRowInfo.bindCustsUI.splice(0, this.curRowInfo.bindCustsUI.length)
      }
    },
    updateGroup (index, info) {
      setTimeout(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      }, 50)
      api.getCustGroupByGroup(info).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let unBind = []
            let unbindUI = []
            Object.assign(unBind, data.Data.unbindCust)
            Object.assign(unbindUI, data.Data.unbindCust)
            this.unbindCusts = unBind
            this.unbindCustsUI = unbindUI
            let bind = []
            let bindUI = []
            Object.assign(bind, data.Data.bindCust)
            Object.assign(bindUI, data.Data.bindCust)
            this.curRowInfo.bindCusts = bind
            this.curRowInfo.bindCustsUI = bindUI
          }
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnSaveLoading = true
          this.btnSaveMsg = '保存中…'
          api.saveCustGroup(this.curRowInfo).then(res => {
            this.btnSaveLoading = false
            this.btnSaveMsg = '保存'
            if (res && res.data) {
              let { status, data } = res
              if (status === 200) {
                if (data.IsOk) {
                  this.dialogFormVisible = false
                  this.initData()
                  this.$message.success(data.Msg)
                } else {
                  this.$message.error(data.Msg)
                }
              }
            }
          })
        }
      })
    },
    editGroup (index, row) {
      // if (this.$refs['form']) {
      //   this.$refs['form'].clearValidate()
      // }
      this.detailTitle = '编辑：'
      if ((row.fGroupName || '').length > 0) {
        this.detailTitle += '【' + row.fGroupName + '】'
      }
      this.canEditGrpNo = false
      Object.assign(this.curRowInfo, row)
      this.curRowInfo.op = 'edit'
      this.curRowInfo.isEdit = true
      this.dialogFormVisible = true
      this.updateGroup(index, this.curRowInfo)
    },
    deleteGroup (index, row) {
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.custGroupDelete(row.fGroupID).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    viewGroup (index, row) {
      // if (this.$refs['form']) {
      //   this.$refs['form'].clearValidate()
      // }
      this.detailTitle = '查看:'
      if ((row.fGroupName || '').length > 0) {
        this.detailTitle += '【' + row.fGroupName + '】'
      }
      this.canEditGrpNo = false
      Object.assign(this.curRowInfo, row)
      this.curRowInfo.isEdit = false
      this.dialogFormVisible = true
      this.updateGroup(index, this.curRowInfo)
    },
    addCustGroup () {
      this.setDefault()
      this.dialogFormVisible = true
      this.operateFlag = 'add'
      this.curRowInfo.op = 'add'
      this.curRowInfo.fGroupID = 0
      this.curRowInfo.isEdit = true
      this.detailTitle = '新增客户分组'
      setTimeout(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      }, 50)
      this.canEditGrpNo = true
      this.updateGroup(0, this.curRowInfo)
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    initData () {
      this.loading = true
      api.custGroupList({
        fGroupName: this.fGroupName,
        fGroupNo: this.fGroupNo,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.total = data.Data.total
              this.groupList = data.Data.rows
            } else {
              this.$message.error('提示：客户分组数据加载失败')
            }
          }
        }
      })
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 210000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
.custGroupEdit .el-checkbox__label {
  display: inline-block;
  padding-left: 10px;
  line-height: 19px;
  font-family: 微软雅黑;
  font-size: 13px;
  padding-top: 0px;
}
.el-textarea .el-textarea__inner {
  resize: none;
}
.custGroupEdit .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.custGroupEdit .el-dialog__title {
  color: white;
}
.custGroupEdit .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.custGroupEdit .el-dialog__body {
  padding-top: 20px;
  padding-left: 20px;
  padding-left: 20px;
  padding-bottom: 0px;
}
.custGroupEdit .el-form-item {
  margin-bottom: 20px;
}
#custGroup .is-disabled .el-input__inner,
#custGroup .is-disabled .el-textarea__inner {
  color: #606266;
}
#custGroup .warning-row {
  color: chocolate;
}
</style>
<style scoped>
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/cust/custGroup.vue